const fileUpload = {
  'file-upload.upload': '上传文件',
  'file-upload.uploading': '上传中...',
  'file-upload.success': '文件上传成功',
  'file-upload.error': '文件上传失败',
  'file-upload.error.message': '文件上传出错',
  'file-upload.formatHint': '支持{accept}文件上传',
  'file-upload.sizeHint.max': '文件大小需小于{maxSize}Mb',
  'file-upload.countLimit': '最多只能上传 {maxCount} 个文件',
  'file-upload.singleFile': '只能上传单个文件',
};

export default fileUpload;
